/**
 * Achat depuis une carte de la page Tarifs v2 : MÊME navigation et MÊME événement GA4 que les
 * cartes v1, pour que le panier (Nouveau Panier, screens/Checkout) reçoive exactement le même état.
 */
import { useLocation, useNavigate } from 'react-router';
import type { MergedPricingContract } from 'screens/Prices/utils/mergePricingService';
import type { Service } from 'types/service';
import { trackSelectItem } from 'utils/tracking';

/** = screens/Prices/components/PackCard.tsx et TopFeatureCard.tsx, `onCheckout`. */
export function useBuyService() {
  const navigate = useNavigate();
  const location = useLocation();
  return (service: Service) => {
    const product = { ...service, type: 'service' as const, IsIntroOffer: !!service.IsIntroOffer };
    trackSelectItem(product as unknown as Record<string, unknown>);
    navigate(`/checkout/id/${product.Id}`, { state: { product, from: location } });
  };
}

/** = screens/Prices/components/ContractCard.tsx, `onClick`. */
export function useSubscribe() {
  const navigate = useNavigate();
  const location = useLocation();
  return (merged: MergedPricingContract) => {
    trackSelectItem({ ...merged.contract, type: 'contract' } as unknown as Record<string, unknown>);
    // `from` (page Tarifs, comme useBuyService) : la pastille « Offre » du panier y revient telle quelle (Checkout/index).
    navigate(`/checkout/contract/${merged.contract.Id}`, {
      state: { contract: merged.contract, merged, from: location },
    });
  };
}
